module.exports = __webpack_public_path__ + "img/ios.570fcfff.jpg";